import IconDynamic from 'bloko/blocks/icon/IconDynamic';
import IconLink from 'bloko/blocks/icon/IconLink';
import IconVerticalAlignment from 'bloko/blocks/icon/IconVerticalAlignment';
import IconColor from 'bloko/blocks/icon/colors.d';

export { IconDynamic, IconLink, IconVerticalAlignment, IconColor };
export * from './variants/icon';
export * from './variants/service';
export * from './variants/social';
